<template>
  <div
    v-if="isLoading"
    class="leo-fixed leo-top-0 leo-left-0 leo-right-0 leo-bottom-0 leo-w-full leo-h-screen leo-z-5 leo-overflow-hidden leo-bg-grey-600 leo-opacity-75 leo-flex leo-flex-col leo-items-center leo-justify-center"
    :class="{ 'loading-white': displayWhiteBackground }"
  >
    <leo-loader />
  </div>
</template>
<script>
import { VueLeoLoader } from "@greateasternlife/leo-loader";
export default {
  name: "Overlay",
  components: {
    "leo-loader": VueLeoLoader,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    displayWhiteBackground: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.loading-white {
  background-color: #fff !important;
  opacity: 1 !important;
}
</style>
